import { render, staticRenderFns } from "./CouponGroupCollapse.vue?vue&type=template&id=06eb03b8&scoped=true"
import script from "./CouponGroupCollapse.vue?vue&type=script&lang=ts"
export * from "./CouponGroupCollapse.vue?vue&type=script&lang=ts"
import style0 from "./CouponGroupCollapse.vue?vue&type=style&index=0&id=06eb03b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eb03b8",
  null
  
)

export default component.exports